import * as React from 'react'
import { SVGProps } from 'react'

// Icon Categories/Article from "icons" page (Figma)
export const SvgReactComponent = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={24}
        height={24}
        viewBox="0 0 24 24"
        {...props}
    >
        <path d="M5.787 15.077v-2.462H8.25v2.462H5.787Z"/>
        <path d="M18.095 5.839A1.846 1.846 0 0 0 16.249 4H3.846A1.846 1.846 0 0 0 2 5.846v11.077A3.077 3.077 0 0 0 5.077 20h13.728a3.077 3.077 0 0 0 3.077-3.077V9.538a1.846 1.846 0 0 0-1.846-1.846h-.71v8.899a.615.615 0 1 1-1.231 0V5.839ZM4.556 8.308a.615.615 0 0 1 .616-.616h9.846a.615.615 0 1 1 0 1.231H5.172a.615.615 0 0 1-.616-.615Zm6.77 3.077h3.692a.615.615 0 0 1 0 1.23h-3.693a.615.615 0 1 1 0-1.23Zm-.616 4.307a.615.615 0 0 1 .615-.615h3.693a.615.615 0 0 1 0 1.23h-3.693a.615.615 0 0 1-.615-.615Zm-5.538-4.307h3.692a.615.615 0 0 1 .615.615v3.692a.616.616 0 0 1-.615.616H5.172a.615.615 0 0 1-.616-.616V12a.615.615 0 0 1 .616-.615Z"/>
    </svg>
);
